import { VStack, Text, HStack, Icon, useToast, Image, } from "@chakra-ui/react";
import { EyeIcon, } from "@heroicons/react/24/outline";
import { useParams, } from "react-router-dom";
import { useQuery, useQueryClient, } from "@tanstack/react-query";
import { cardIssuanceStatusQueryConfig, cardRequisitesQueryConfig, } from "../../../../api";
import card from "../../../../assets/card.svg";
import { usePopupWindow, } from "../../../../utils/hooks";

const toastId = "LimitCardPreviewFetchError";

export function LimitCardPreview() {
  const limitId = useParams().id!;
  const toast = useToast({ id: toastId, },);
  const queryClient = useQueryClient();
  const cardIssuanceStatus = useQuery({
    ...cardIssuanceStatusQueryConfig(limitId,),
    retry: false,
  },);
  const cardRequisitesLinkQuery = useQuery({
    ...cardRequisitesQueryConfig(limitId,),
    // fetch only on user interaction
    enabled: false,
  },);
  const { openPopup, setUrl, } = usePopupWindow();

  const handleCardRequisites = () => {
    openPopup();
    cardRequisitesLinkQuery
      .refetch({ throwOnError: true, },)
      .then((data,) => {
        if (data.isSuccess) {
          setUrl(data.data.url,);
          void queryClient.invalidateQueries({
            queryKey: ["paymentCardRequisites",],
          },);
        }
      },)
      .catch(() => {
        toast({
          description: "Не удалось загрузить данные, попробуйте ещё раз или повторите чуть позже.",
        },);
      },);
  };

  return (
    cardIssuanceStatus.isSuccess && (cardIssuanceStatus.data === "ACTIVE") && (
      <VStack
        spacing={4}
        align="stretch"
        w="194px"
        mx="auto"
      >
        <Image src={card} width="100%" />

        <HStack
          spacing={2}
          align="center"
          justify="center"
          fontSize="sm"
          color="purple.500"
          cursor="pointer"
          _hover={{ color: "purple.600", }}
        >
          <Icon as={EyeIcon} />
          <Text onClick={handleCardRequisites}>Показать реквизиты</Text>
        </HStack>
      </VStack>
    )
  );
}
